
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import StoreUtil from '@/stores/StoreUtil'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import useEnterAccount from './hook/useEnterAccount'

export default defineComponent({
  name: 'EnterAccountPage',
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')
    const { enterAccount, isSendingEnterAccount } = useEnterAccount()

    onMounted(() => {
      let propertyNames = [
        'tokenId',
        'displayName',
        'username',
        'password',
      ] as (keyof typeof enterAccountStore)[]
      if (enterAccountStore.hasAffiliatedOrganizations) {
        // 既に他組織に所属済みユーザの新規組織作成のとき
        propertyNames = ['tokenId', 'displayName']
      } else if (enterAccountStore.isExistingAccount) {
        // 既に他組織に所属済みユーザが他チームに招待されたとき
        propertyNames = ['tokenId', 'accessToken']
      }
      useValidateForAccess('EnterAccountStore', propertyNames, 'ErrorPage')
    })
    return {
      enterAccountStore,
      t,
      isSendingEnterAccount,
      enterAccount,
      onClickBack() {
        enterAccountStore.password = ''
        let name = 'RegistPage'
        if (enterAccountStore.isExistingAccount) {
          name = 'AddTeamPage'
        } else if (enterAccountStore.isInvitedUser) {
          name = 'InvitePage'
        }
        router.replace({
          name,
          query: { tokenId: enterAccountStore.tokenId },
        })
      },
    }
  },
  components: {
    RegisterFlow,
  },
})
